import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { FontStyrene as Component } from './font-styrene';
import type { IDeps, TProps } from './models';
import styles from './styles/font-styrene.css';

export const FontStyrene = createWidget<IDeps, TProps>({
    styles,
})(Component);
